import { render, staticRenderFns } from "./ZonesFormModify.vue?vue&type=template&id=b8b0890a&scoped=true"
import script from "./ZonesFormModify.vue?vue&type=script&lang=js"
export * from "./ZonesFormModify.vue?vue&type=script&lang=js"
import style0 from "./ZonesFormModify.vue?vue&type=style&index=0&id=b8b0890a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b0890a",
  null
  
)

export default component.exports